import get from 'lodash.get';

export const selectConfigure = state => get(state, 'setup.configure');
export const selectConfigureProgress = state => get(selectConfigure(state), 'progress');
